const  servicesData = [
  {
    category: "Home Services",
    profession: [
      {
        name: "Electrical",
        skills: ["Electrician", "Fan/Geyser Installation", "Switchboard Fixing"]
      },
      {
        name: "Plumbing",
        skills: ["Plumber", "Water Tank Cleaning", "RO Installation"]
      },
      {
        name: "Cleaning",
        skills: ["Bathroom Cleaning", "Kitchen Deep Cleaning", "Sofa/Carpet Cleaning"]
      },
      {
        name: "Carpentry",
        skills: ["Carpenter", "Furniture Repair", "Door/Window Fixing"]
      },
      {
        name: "Painting",
        skills: ["Wall Painter", "Texture Painter"]
      },
      {
        name: "Pest Control",
        skills: ["Cockroach Control", "Termite Control"]
      }
    ]
  },
  {
    category: "Home & Elderly Care",
    profession: [
      {
        name: "Elderly Care",
        skills: ["Home Caregiver", "Night Caregiver"]
      },
      {
        name: "Baby & Postpartum Care",
        skills: ["Baby Caregiver", "Postnatal Nurse"]
      },
      {
        name: "Medical Assistance",
        skills: ["Home Nurse", "Physiotherapist"]
      }
    ]
  },
  {
    category: "Appliance Services",
    profession: [
      {
        name: "Installation",
        skills: ["AC Installation", "TV Wall Mounting", "Inverter Setup"]
      },
      {
        name: "Repair",
        skills: ["AC Repair", "Washing Machine Repair", "Fridge Repair"]
      }
    ]
  },
  {
    category: "Events & Entertainment",
    profession: [
      {
        name: "Performers",
        skills: ["Singer", "Dancer", "DJ"]
      },
      {
        name: "Photography",
        skills: ["Event Photographer", "Baby Shoot Expert", "Videographer"]
      },
      {
        name: "Decoration",
        skills: ["Balloon Decorator", "Thematic Decorator"]
      }
    ]
  },
  {
    category: "Beauty & Wellness",
    profession: [
      {
        name: "Salon at Home",
        skills: ["Beautician (Women)", "Hairdresser (Men)"]
      },
      {
        name: "Massage",
        skills: ["Male Therapist", "Female Therapist"]
      },
      {
        name: "Fitness",
        skills: ["Yoga Instructor", "Personal Trainer"]
      }
    ]
  },
  {
    category: "Education & Training",
    profession: [
      {
        name: "Tutors",
        skills: ["Home Tutor (School Subjects)", "Spoken English Tutor"]
      },
      {
        name: "Hobby Classes",
        skills: ["Music Teacher (Guitar/Keyboard)", "Drawing Instructor"]
      }
    ]
  },
  {
    category: "Installation & IT Setup",
    profession: [
      {
        name: "Electronics",
        skills: ["CCTV Installation", "Doorbell Camera Setup"]
      },
      {
        name: "Networking",
        skills: ["Wi-Fi Router Setup", "LAN Cable Technician"]
      }
    ]
  },
  {
    category: "Vehicle Care",
    profession: [
      {
        name: "Mechanic",
        skills: ["Bike Mechanic", "Car Mechanic"]
      },
      {
        name: "Cleaning",
        skills: ["Car Wash at Home", "Interior Detailing"]
      }
    ]
  }
];



export default servicesData